import { Link } from "react-router-dom";
import { comics, featuredComic } from "@/mocks/comics";
import ComicCard from "@/components/base/ComicCard";

export default function HotRanking() {
  const ranking = [...comics]
    .sort((a, b) => Number(b.rating) - Number(a.rating))
    .slice(0, 5);

  const rankColors = ["bg-primary-500", "bg-accent-500", "bg-secondary-500", "bg-background-300", "bg-background-300"];

  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-fire-fill" aria-hidden="true" /> HOT
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">人气排行榜</h2>
            <p className="mt-2 text-sm text-foreground-700">大家都在看的漫画，好评如潮</p>
          </div>
          <Link
            to="/category/all?sort=hot"
            className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看完整榜单 <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* Featured card */}
          <div className="lg:col-span-1">
            <Link
              to={`/manga/${featuredComic.id}`}
              className="group relative flex h-full flex-col overflow-hidden rounded-lg bg-background-100"
              aria-label={`查看漫画《${featuredComic.title}》详情`}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={featuredComic.cover}
                  alt={`${featuredComic.title}封面`}
                  title={`${featuredComic.title}漫画免费阅读`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="rounded-md bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">本站热门</span>
                  <h3 className="mt-2 font-heading text-lg font-bold text-background-50">{featuredComic.title}</h3>
                  <p className="mt-1 line-clamp-2 text-xs text-background-50/80">{featuredComic.description}</p>
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-x-4 gap-y-2 px-4 py-4 text-xs text-foreground-700">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500" aria-hidden="true" /> {featuredComic.rating}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true" /> {featuredComic.views} 人气
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-bookmark-line" aria-hidden="true" /> {featuredComic.chapters.length} 话
                </span>
                <span className="ml-auto rounded-md bg-secondary-100 px-2 py-0.5 text-secondary-900">{featuredComic.status}</span>
              </div>
            </Link>
          </div>

          {/* Ranking list */}
          <div className="lg:col-span-2">
            <ol className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {ranking.map((comic, index) => (
                <li key={comic.id}>
                  <Link
                    to={`/manga/${comic.id}`}
                    className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-3 transition-colors hover:border-primary-300 hover:bg-background-50"
                  >
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black text-background-50 ${rankColors[index]}`}
                    >
                      {index + 1}
                    </span>
                    <div className="h-14 w-11 shrink-0 overflow-hidden rounded-md">
                      <img
                        src={comic.cover}
                        alt={`${comic.title}封面`}
                        title={`${comic.title}漫画`}
                        className="h-full w-full object-cover object-top"
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                      <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                        {comic.title}
                      </h3>
                      <p className="mt-1 truncate text-xs text-foreground-700">{comic.latestChapter}</p>
                      <p className="mt-0.5 text-xs text-foreground-600">
                        更新于 {comic.updatedAt}
                      </p>
                    </div>
                    <span className="flex shrink-0 items-center gap-1 text-xs font-bold text-accent-600">
                      <i className="ri-star-fill" aria-hidden="true" /> {comic.rating}
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
            <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-4">
              <ComicCard comic={comics[6]} />
              <ComicCard comic={comics[7]} />
              <ComicCard comic={comics[8]} />
              <ComicCard comic={comics[9]} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}